import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { CSAlertConfiguration } from "../Model/CSAlertConfiguration";

export async function deleteCSAlertConfiguration(idCSAlertConfiguration) {
	let response = await getAPIResponse("/v1/cs/alert-configuration/"+idCSAlertConfiguration, {}, "DELETE");
	if (response === null) {
		return null;
	}
	let CSAlertConfigurationObj = CSAlertConfiguration.createFromResponseData(response);
	return CSAlertConfigurationObj;
}